/**
 * Parse a `SEARCH_DEFAULT_PLACE_TYPE` feature value into a base place type.
 * Only the exact strings `'terminal'` and `'city'` are valid. Anything else
 * (empty, other case, whitespace, non-string) means "no base filter".
 * @param {*} value - Raw feature flag value.
 * @returns {'terminal'|'city'|null} The base place type, or null when there is none.
 */
export const parseSearchDefaultPlaceType = (value) =>
  value === 'terminal' || value === 'city' ? value : null;

export default parseSearchDefaultPlaceType;
